import React, { createContext, useState, useContext, useEffect } from "react";
import { getDatabase, ref, get, onValue } from "firebase/database";
import { app } from "../firebase/config";
import { useLocation, Navigate } from "react-router-dom";

const MaintenanceContext = createContext();

export const useMaintenanceMode = () => {
  const context = useContext(MaintenanceContext);
  if (!context) {
    throw new Error(
      "useMaintenanceMode must be used within a MaintenanceProvider"
    );
  }
  return context;
};

const ALLOWED_PATHS = ["/", "/admin"];

export const MaintenanceProvider = ({ children }) => {
  const [isMaintenanceMode, setIsMaintenanceMode] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const db = getDatabase(app);
    const maintenanceModeRef = ref(db, "system/maintenanceMode");

    // OPTIMIZED: Thay thế realtime listener bằng polling
    // Maintenance mode hiếm khi thay đổi, không cần realtime connection
    // Điều này giảm overhead bandwidth và số lượng concurrent connections
    const checkMaintenanceMode = async () => {
      try {
        const snapshot = await get(maintenanceModeRef);
        if (snapshot.exists()) {
          setIsMaintenanceMode(snapshot.val());
        } else {
          setIsMaintenanceMode(false);
        }
        setIsLoading(false);
      } catch (error) {
        console.error("Error checking maintenance mode:", error);
        setIsLoading(false);
      }
    };

    // Kiểm tra ngay lập tức khi mount
    checkMaintenanceMode();

    // Kiểm tra lại mỗi 5 phút thay vì realtime listener
    // 5 phút delay là chấp nhận được cho feature hiếm dùng
    const interval = setInterval(checkMaintenanceMode, 5 * 60 * 1000);

    // Cleanup interval khi unmount
    return () => {
      clearInterval(interval);
    };
  }, []);

  const value = {
    isMaintenanceMode,
    isLoading,
  };

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const MaintenanceGuard = ({ children }) => {
  const { isMaintenanceMode, isLoading } = useMaintenanceMode();
  const location = useLocation();

  if (isLoading) {
    return <div></div>;
  }

  if (isMaintenanceMode && !ALLOWED_PATHS.includes(location.pathname)) {
    return (
      <div className="maintenance-mode">
        <div className="maintenance-content">
          <h1>🛠️ Hệ thống đang bảo trì</h1>
          <p>
            Chúng tôi đang nâng cấp hệ thống để mang lại trải nghiệm tốt hơn.
          </p>
          <p>Vui lòng quay lại sau. Xin cảm ơn!</p>
          <button onClick={() => (window.location.href = "/")}>
            Về trang chủ
          </button>
        </div>
      </div>
    );
  }

  return children;
};
